"use strict";

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIOS = isIOS;
exports.isOpera = isOpera;
exports.isFirefox = isFirefox;
exports.isSafari = isSafari;
exports.isIE = isIE;
exports.isEdge = isEdge;
exports.isChrome = isChrome;
exports.isBlink = isBlink;

/**
 ********** WARNING *******
 * These utils are only intended for displaying simple help content such us:
 *
 * 				"These documents may not display properly on Safari"
 *
 *  Usage for any application functionality is not recommend as this can be easily spoofed
 *
 * Ref: https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser/9851769
 */

/**
 * Check for IOS device
 * @returns {boolean}
 */
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
/**
 * Check for Opera 8.0+
 * @returns {boolean}
 */


function isOpera() {
  return !!window.opr && !!window.opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
}
/**
 * Check for Firefox 1.0+
 * @returns {boolean}
 */


function isFirefox() {
  return typeof InstallTrigger !== 'undefined';
}
/**
 * Check for Safari 3.0+ "[object HTMLElementConstructor]"
 * @returns {boolean}
 */


function isSafari() {
  return /constructor/i.test(window.HTMLElement) || function (p) {
    return p.toString() === '[object SafariRemoteNotification]';
  }(!window.safari || typeof window.safari !== 'undefined' && window.safari.pushNotification);
}
/**
 * Check for Internet Explorer 6-11
 * @returns {boolean}
 */


function isIE() {
  return (
    /*@cc_on!@*/
    false || !!document.documentMode
  );
}
/**
 * Check for Edge 20+
 * @returns {boolean}
 */


function isEdge() {
  return !isIE() && !!window.StyleMedia;
}
/**
 * Check for Chrome 1+
 * @returns {boolean}
 */


function isChrome() {
  return !!window.chrome && !!window.chrome.webstore;
}
/**
 * Check for Blink engine detection
 * @returns {boolean}
 */


function isBlink() {
  return (isChrome() || isOpera()) && !!window.CSS;
}
//# sourceMappingURL=BrowserUtils.js.map